export const REQUIRED = 'You need to fill in this bit'
export const INVALID_PASSWORD = 'Must be 8 characters consisting of uppercase, lowercase and numbers'
export const PASSWORD_MISMATCH = 'Password does not match'
export const INVALID_EMAIL = 'Email address is invalid'
export const NUMBER_PLATE = 'Please enter between 2 and 7 characters using only numbers and letters'
export const TEL_LENGTH_BREACH = 'Phone number must be between 10 and 15 characters long'
export const INVALID_TEL = 'Phone number should only include numbers and "(", ")", "+" characters'
export const MARKETING_PREF = 'You must select at least one communication preference'
export const NUMBER_ERROR = 'Please enter a number'
export const MONTHS_ERROR = 'Please enter a valid month number'
export const MONTHS_USE_YEARS_ERROR = 'Please add a year instead of using 12 months'
